import styles from './MobileAppDevelopment.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const MobileAppDevelopment: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.summary} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.sectionTitle}>
          ただ作るだけでは終わらせない。
          <br />
          ビジネスの成果を導くスマホアプリ開発。
        </h2>
        <div className={styles.spBox}>
          <p className={styles.spBox__text}>
            企業の成長を支える“ユーザー体験起点のアプリ開発”を提供します。
            <br />
            構想からUX/UI、開発、運用までをワンチームで伴走し、金融・不動産・人材・情報通信・小売など、さまざまな業界で培ったUXとテクノロジーの力で、ビジネスの変革を加速させます。
          </p>
          <ul className={styles.FVLink}>
            <li className={styles.FVLink__itemBlack}>
              <a href="/services/mobile-app-development/">アプリ開発の詳細はこちら</a>
            </li>
            <li className={styles.FVLink__itemWhite}>
              <a href="/download/application-development/">関連PDF資料はこちら</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default MobileAppDevelopment
